import request from '@/utils/request'

/**
* 用户操作记录API
*
* @author ljw
* @since 2025/03/27
*/

/**
* 基础接口
*
* @type {string}
*/
export const BASE_URL = 'manager/operation-record'

/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}
